import { gql } from '@apollo/client';
import { ChatMessage } from '@app/hooks/types';

export const AUDIT_CHAT_FIELDS = gql`
  fragment AuditChatFields on AuditChat {
    id
    createdAt
    updatedAt
    messages {
      role
      content
    }
    length
    applicationId
  }
`;

export interface AuditChat {
  id: string;
  createdAt: string;
  updatedAt: string;
  messages: ChatMessage[];
  length: number;
  applicationId: string;
}
